import React from "react";
import { useTranslation } from "react-i18next";
import {
  StyledModalBody,
  StyledModal,
  StyledModalFooter,
} from "../styledComponents/StyledModals";

export const DepositStartingDialog = ({ showModal, message }) => {
  const { t } = useTranslation("");
  return (
    <StyledModal isOpen={showModal}>
      <StyledModalBody
        register
        dangerouslySetInnerHTML={{ __html: t(message) }}
      ></StyledModalBody>
      <StyledModalFooter></StyledModalFooter>
    </StyledModal>
  );
};
